/* eslint-disable */
import React from 'react'
import {Icon, message} from 'antd'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {saveAs} from 'file-saver'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import cookie from 'react-cookies'
import {baseURL} from '../BaseComponent/configTheme'
import $ from 'jquery'
import jMoment from 'moment-jalaali'

import {ExcelExport, grid, gridColumn, ExcelExportColumn} from '@progress/kendo-react-excel-export'
import Loader from '../loaders/loader'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import AutoComplete from '../BaseComponent/autocomplete'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class WarehouseProductPrice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: '',

      providers: [],
      loading: false,
      providerId: '',
      excel: [],
      date: moment(),
      warehouseProductType: '',
      providerId: '',
      provider: {}
    }
  }
  componentDidMount() {
    // http
    //   .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
    //   .then((response) => {
    //     if (response.data.error == null) {
    //       var result = response.data.object;
    //       for (let i = 0; i < result.length; i++) {
    //         result[i]["value"] = result[i].providerId;
    //         result[i]["label"] =
    //           "شناسه :" + result[i].providerId + "-" + result[i].title;
    //       }
    //       this.setState({
    //         providers: response.data.object,
    //       });
    //     }
    //     // alert(JSON.stringify(response.data))
    //   })
    //   .catch((error) => {
    //     alert(JSON.stringify(error));
    //   });
  }

  submit(e) {
    e.preventDefault()
  }

  handleDateChange = (date) => {
    this.setState({
      date
    })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  orderProvider() {
    let date = this.state.date

    let providerId = this.state.providerId

    const {warehouseProductType} = this.state

    if (date === null) {
      message.error('فیلدهای ستاره دار وارد شود')
    } else {
      JASPERREPORT(
        `report/jasper/warehouse/product-price?fromTime=${this.epochFrom(date)}&toTime=${this.epochTo(
          date
        )}&providerId=${providerId}&warehouseProductType=${warehouseProductType}`
      )
    }
  }

  getExcel = () => {
    let date = this.state.date
    let providerId = this.state.providerId

    const {warehouseProductType} = this.state

    if (date === null) {
      message.error('فیلدهای ستاره دار وارد شود')
    } else {
      this.setState({
        loading: true
      })
      http
        .get(
          `report/jasper/warehouse/product-price/json?fromTime=${this.epochFrom(date)}&toTime=${this.epochTo(
            date
          )}&providerId=${providerId}&warehouseProductType=${warehouseProductType}`
        )
        .then((res) => {
          this.setState({
            loading: false
          })
          if (res.data.error === null) {
            this.setState(
              {
                excel: res.data.object.productPriceWarehouseOuts
              },
              () => {
                this._export.save(this.state.excel)
              }
            )
          }
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  handleChange = (providerId) => {
    this.setState({providerId})
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  getAnotherExcel = () => {
    let date = this.state.date
    let providerId = this.state.providerId
    const {warehouseProductType} = this.state

    let residAnbarShomare = document.getElementById('residAnbarShomare').value
    if (date === null) {
      message.error('فیلدهای ستاره دار وارد شود')
    } else {
      this.setState({
        loading: true
      })
      http
        .get(
          `report/jasper/warehouse/product-price/json?fromTime=${this.epochFrom(date)}&toTime=${this.epochTo(
            date
          )}&providerId=${providerId}&warehouseProductType=${warehouseProductType}`
        )
        .then((res) => {
          this.setState({
            loading: false
          })
          if (res.data.error === null) {
            this.setState(
              {
                excel: res.data.object.productPriceWarehouseOuts,
                sepidarFileName:
                  (this.state.providerId ? this.state.provider.title : '') +
                  this.convertDigit(jMoment(this.state.date).format('jYYjMMjDD')) +
                  ' - ' +
                  'قیمت کالاهای وارده' +
                  '.xls'
              },
              () => {
                let excel = this.state.excel
                let temp = residAnbarShomare
                let providerIFlag = ''
                for (let i = 0; i < this.state.excel.length; ) {
                  providerIFlag = excel[i].providerId
                  while (i < this.state.excel.length && providerIFlag === excel[i].providerId) {
                    excel[i].resideAnbarNumber = +temp
                    i++
                  }
                  temp++
                }
                this.setState({
                  excel
                })

                this.state.excel.forEach((item, index) => {
                  item.itemType = 'InventoryReceiptItem'
                  item.resideAnbarItemType = '1'
                  item.resideAnbarResidType = '3'
                  item.resideAnbarNumber = residAnbarShomare === '' ? '' : item.resideAnbarNumber

                  // item.resideAnbarDate = 'ق.ظ' + ' - ' + '12:00:00' + ' - ' + this.convertDigit(jMoment(this.state.date).format('jYY/jMM/jDD'))
                  item.resideAnbarDate =
                    this.convertDigit(jMoment(this.state.date).format('jYY/jMM/jDD')) + ' ' + '12:00:00' + ' ق.ظ'
                  item.anbarCode = '11'
                  item.receiverAnbarCode = '4910005'
                  item.anbarCodeMoein = '211001'
                  item.carearAnbar = ''
                  item.anbarRadyabi = ''
                  item.ghalamResideAnbareAsli = ''
                  item.ghalamResideAnbareFarii = ''
                  item.ghalamResideTax = '0'
                  item.ghalamResideAvarez = '0'
                  item.ghalamResideKeraye = ''
                  item.ghalamResideAnbarMaliat = ''
                  item.ghalamResideAnbareAvarezeHaml = ''
                  item.resideAnbarCodeTahvilDahande = item.externalId === null ? item.providerId : item.externalId
                  item.ghalamResideAnbareKol = +item.quantity * +item.unitProviderPayable
                })
                this._anotherExcel.save(this.state.excel)
              }
            )
          }
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  render() {
    return (
      <div className="rtl">
        <Loader show={this.state.loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش قیمت کالاهای وارده به انبار.xls"
          >
            <ExcelExportColumn
              key={'articleId'}
              field={'articleId'}
              title={'شناسه محصول'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'barCode'}
              field={'barCode'}
              title={'بارکد محصول'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'productName'}
              field={'productName'}
              title={'عنوان محصول'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'providerName'}
              field={'providerName'}
              title={'تامین کننده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'unitPrice'}
              field={'unitPrice'}
              title={'قیمت اولیه واحد'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'providerDiscount'}
              field={'providerDiscount'}
              title={'تخفیف واحد تامین کننده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'unitProviderPayable'}
              field={'unitProviderPayable'}
              title={'پرداختی واحد به تامین کننده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'quantity'}
              field={'quantity'}
              title={'مقدار تحویل گرفته شده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'productUnitTitle'}
              field={'productUnitTitle'}
              title={'واحد'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'commissionAmount'}
              field={'commissionAmount'}
              title={'کمیسیون کل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'providerPayable'}
              field={'providerPayable'}
              title={'پرداختی کل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'externalId'}
              field={'externalId'}
              title={'کد تامین کننده ( در واحد مالی)'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._anotherExcel = exporter
            }}
            fileName={this.state.sepidarFileName}
          >
            <ExcelExportColumn
              key={'itemType'}
              field={'itemType'}
              title={'نوع قلم'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'resideAnbarItemType'}
              field={'resideAnbarItemType'}
              title={'رسید انبار نوع خرید'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'resideAnbarResidType'}
              field={'resideAnbarResidType'}
              title={'رسید انبار نوع رسید'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'resideAnbarNumber'}
              field={'resideAnbarNumber'}
              title={'رسید انبار شماره'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'resideAnbarDate'}
              field={'resideAnbarDate'}
              title={'رسید انبار تاریخ'}
              footerCellOptions={{wrap: true, textAlign: 'left'}}
            />
            <ExcelExportColumn
              key={'anbarCode'}
              field={'anbarCode'}
              title={'رسید انبار کد انبار'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'resideAnbarCodeTahvilDahande'}
              field={'resideAnbarCodeTahvilDahande'}
              title={'رسید انبار کد تحویل دهنده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'anbarCodeMoein'}
              field={'anbarCodeMoein'}
              title={'رسید انبار کد حساب معین'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'barCode'}
              field={'barCode'}
              title={'قلم رسید کد انبار'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'x'}
              field={'x'}
              title={'رسید انبار کد حمل کننده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'y'}
              field={'y'}
              title={'قلم رسید انبار ردیابی 1'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'quantity'}
              field={'quantity'}
              title={'قلم رسید انبار واحد اصلی'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'z'}
              field={'z'}
              title={'قلم رسید انبار واحد فرعی'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'unitProviderPayable'}
              field={'unitProviderPayable'}
              title={'قلم رسید انبار فی'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'ghalamResideAnbareKol'}
              field={'ghalamResideAnbareKol'}
              title={'قلم رسید انبار کل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'ghalamResideTax'}
              field={'ghalamResideTax'}
              title={'قلم رسید انبار مالیات'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'ghalamResideAvarez'}
              field={'ghalamResideAvarez'}
              title={'قلم رسید انبار عوارض'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'ww'}
              field={'ww'}
              title={'قلم رسید انبار کرایه حمل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'g'}
              field={'g'}
              title={'قلم رسید انبار مالیات حمل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'l'}
              field={'l'}
              title={'قلم رسید انبار عوارض حمل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'l'}
              field={'l'}
              title={'قلم رسید انبار ارجاع تحویل فروش چک'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'l'}
              field={'l'}
              title={'قلم رسید انبار ارجاع فروش چک '}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'l'}
              field={'l'}
              title={'رسید انبار کد واسط حمل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'l'}
              field={'l'}
              title={'رسید انبار واسط حمل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'l'}
              field={'l'}
              title={'رسید انبار معین واسط حمل'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>مالی</li>
            <li>گزارش قیمت کالاهای وارده به انبار</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش قیمت کالاهای وارده به انبار</p>
            </div>

            <div className="formComponent">
              <label className="font-weight-bold">
                تاریخ :<span className="requireFiled font-weight-bold">*</span>
              </label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  inline
                  okLabel="تأیید"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  cancelLabel="لغو"
                  labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                  value={this.state.date}
                  id="date"
                  onChange={this.handleDateChange}
                  TextFieldComponent={this.date}
                  readOnly
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className="formComponent">
              <label className="font-weight-bold">ماهیت</label>
              <select
                className="form-control"
                id="warehouseProductType"
                name="warehouseProductType"
                onChange={(e) => this.setState({warehouseProductType: e.target.value})}
              >
                <option value="">هردو</option>
                <option value="RECEIVED_FROM_PROVIDER">دریافت از تامین کننده</option>
                <option value="RETURNED_TO_PROVIDER">مرجوع به تامین کننده</option>
              </select>
            </div>

            <div className="formComponent">
              <AutoComplete
                label="تامین کننده"
                api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                textField="title"
                valueField="providerId"
                id="provider"
                value={this.state.providerId}
                setValue={(providerId) => this.setState({providerId})}
                selected={(provider) => this.setState({provider})}
              />
              {/* <label className="font-weight-bold">تامین کننده :</label>
              <Select
                value={this.state.providerId}
                onChange={this.handleChange}
                options={this.state.providers}
                isMulti={false}
                isClearable={true}
                placeholder={""}
                tabIndex="1"
              /> */}
            </div>
            <div className="formComponent">
              <label className="font-weight-bold">رسید انبار شماره :</label>
              <input type="number" id="residAnbarShomare" className="form-control" />
            </div>

            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.orderProvider.bind(this)}>
                گزارش قیمت کالاهای وارده به انبار
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getExcel}>
                خروجی اکسل
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getAnotherExcel}>
                فرمت سپیدار سیستم
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default WarehouseProductPrice
